const DEFAULT_API_BASE = "https://volunteers-impact-initiative-backend-u253.onrender.com";
const USER_API_PREFIX = "api/user";
const EVENTS_API_PREFIX = "api/events";
const MEDIA_API_PREFIX = "api/media";
const CONTACT_API_PREFIX = "api/contact";
const VOLUNTEERS_API_PREFIX = "api/volunteers";

function stripTrailingSlash(s) {
  return s.replace(/\/+$/, "");
}

function stripEdgeSlashes(s) {
  return s.replace(/^\/+|\/+$/g, "");
}

export function getApiBase() {
  const raw = process.env.REACT_APP_API_BASE;
  if (raw != null && String(raw).trim() === "") return "";
  if (raw != null && String(raw).trim()) {
    return stripTrailingSlash(String(raw).trim());
  }
  return DEFAULT_API_BASE;
}

export function userApiUrl(pathSegment) {
  const base = getApiBase();
  if (!base) return "";
  const rest = pathSegment ? stripEdgeSlashes(pathSegment) : "";
  return rest ? `${base}/${USER_API_PREFIX}/${rest}` : `${base}/${USER_API_PREFIX}`;
}

export function eventsApiUrl(pathSegment) {
  const base = getApiBase();
  if (!base) return "";
  const rest = pathSegment ? stripEdgeSlashes(pathSegment) : "";
  return rest ? `${base}/${EVENTS_API_PREFIX}/${rest}` : `${base}/${EVENTS_API_PREFIX}`;
}

export function getMediaApiPathPrefix() {
  return stripEdgeSlashes(process.env.REACT_APP_MEDIA_API_PATH || MEDIA_API_PREFIX);
}

export function mediaApiUrl(pathSegment) {
  const base = getApiBase();
  const prefix = getMediaApiPathPrefix();
  if (!base) return "";
  const rest = pathSegment ? stripEdgeSlashes(pathSegment) : "";
  return rest ? `${base}/${prefix}/${rest}` : `${base}/${prefix}`;
}

export function getContactApiPathPrefix() {
  return stripEdgeSlashes(process.env.REACT_APP_CONTACT_API_PATH || CONTACT_API_PREFIX);
}

export function contactApiUrl(pathSegment) {
  const base = getApiBase();
  const prefix = getContactApiPathPrefix();
  if (!base) return "";
  const rest = pathSegment ? stripEdgeSlashes(pathSegment) : "";
  return rest ? `${base}/${prefix}/${rest}` : `${base}/${prefix}`;
}

export function getVolunteersApiPathPrefix() {
  return stripEdgeSlashes(process.env.REACT_APP_VOLUNTEERS_API_PATH || VOLUNTEERS_API_PREFIX);
}

export function volunteersApiUrl(pathSegment) {
  const base = getApiBase();
  const prefix = getVolunteersApiPathPrefix();
  if (!base) return "";
  const rest = pathSegment ? stripEdgeSlashes(pathSegment) : "";
  return rest ? `${base}/${prefix}/${rest}` : `${base}/${prefix}`;
}
